import { createIcon } from '@chakra-ui/icons';

export const ShortAnswerSimple = createIcon({
  displayName: 'ShortAnswerSimple',
  viewBox: '0 0 13 11',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
      <path
        d="M1.25013 9.00019C1.31088 9.00019 1.37163 8.99269 1.43163 8.97769L4.43163 8.22769C4.56363 8.19469 4.68438 8.12644 4.78038 8.03044L9.28038 3.53044C9.57363 3.23719 9.57363 2.76319 9.28038 2.46994L7.03038 0.219938C6.73713 -0.0733125 6.26313 -0.0733125 5.96988 0.219938L1.46988 4.71994C1.37388 4.81594 1.30563 4.93669 1.27263 5.06794L0.522626 8.06794C0.458126 8.32369 0.533876 8.59369 0.719876 8.78044C0.861626 8.92294 1.05363 9.00019 1.25013 9.00019ZM2.67738 5.63344L6.50013 1.81069L7.68963 3.00019L3.86613 6.82294L2.28063 7.21894L2.67738 5.63344Z"
        fill="currentColor"
      />
      <path
        d="M11.7502 10.5005H1.25024C0.835494 10.5005 0.500244 10.8365 0.500244 11.2505C0.500244 11.6645 0.835494 12.0005 1.25024 12.0005H11.7502C12.165 12.0005 12.5002 11.6645 12.5002 11.2505C12.5002 10.8365 12.165 10.5005 11.7502 10.5005Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
